<template>
  <div>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      @click="dialog = true"
      style="top: 10px"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <newUserDialog
      :newUserDialog="dialog"
      @setDialog="dialog = $event"
    ></newUserDialog>
    <editUserDialog
      :selectedItem="selectedItem"
      :originalUser="originalUser"
      :editDialog="editDialog"
      @setDialog="editDialog = $event"
      @setOriginal="originalUser = $event"
    ></editUserDialog>
    <v-layout row>
      <!-- <v-flex xs8>
        <v-spacer></v-spacer>
      </v-flex>-->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :search="search"
      :loading="
        userData.length == 0 && loadingMessage == 'black'
          ? loadingMessage
          : false
      "
      :items="filterdUserData"
      :pagination.sync="pagination"
    >
      <template
        slot="items"
        slot-scope="props"
        v-if="props.item.user_role != 6"
      >
        <td class="text-xs-left">{{ props.item.user_country_tel }}</td>
        <td class="text-xs-left">{{ props.item.user_tel }}</td>
        <td class="text-xs-left">{{ props.item.user_email }}</td>
        <td class="text-xs-left">{{ nameCheck(props.item) }}</td>
        <td class="text-xs-left">{{ roleCheck(props.item) }}</td>
        <td class="text-xs-left">{{ typeCheck(props.item) }}</td>

        <td class="text-xs-center">
          <v-tooltip top>
            <v-btn
              :loading="fetching_address == props.item.user_id"
              icon
              @click="editAddress(props.item)"
              slot="activator"
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View</span>
          </v-tooltip>
        </td>
        <td class="text-xs-left">
          <v-checkbox-otp
            otpTel="974563956"
            :isAlreadyCheck="alreadyCheckOTP"
            v-model="props.item.user_vip"
            @change="setVIP($event, props.item)"
          />
        </td>
        <td
          class="justify-center layout px-0"
          v-if="indexEditLoading != props.index"
        >
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :disabled="isEditStaff"
              @click="editItem(props.item)"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :disabled="isEditStaff"
              @click="deleteItem(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
        <td
          class="justify-center layout px-0"
          v-if="indexEditLoading == props.index"
        >
          Editing...
        </td>
      </template>

      <template slot="no-data">
        <div v-if="userData.length == 0 && loadingMessage != 'black'">
          No data available
          <br />
          <v-btn @click="getData()">Reset</v-btn>
        </div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ loadingMessage == "black" ? "Loading data ..." : loadingMessage }}
        </div>
      </template>
    </v-data-table>
    <addressList
      :selectedCustomer="selectedCustomer"
      :dialog="addressListDialog"
      @setDialog="addressListDialog = $event"
      @cancel="cancelEdit()"
    />
    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import newUserDialog from "./NewUser";
import editUserDialog from "./EditUser.vue";
import addressList from "@/components/back-office/CustomerManagement/AddressList.vue";
export default {
  data: () => ({
    search: "",
    loadingMessage: "black",
    pagination: {
      rowsPerPage: 10,
    },
    addressListDialog: false,
    fetching_address: null,
    selectedItem: null,
    dialog: false,
    editDialog: false,
    selectedCustomer: null,
    originalUser: null,
    headers: [
      {
        text: "Country code",
        sortable: false,
        value: "user_country_tel",
      },
      {
        text: "Tel.",
        sortable: false,
        value: "user_tel",
      },
      {
        text: "Email",
        value: "user_email",
        sortable: false,
      },
      {
        text: "Name",
        value: "user_full_name_temp",
        sortable: false,
      },
      {
        text: "Role",
        value: "user_role_name_temp",
        sortable: false,
      },
      {
        text: "type",
        value: "user_type_name_temp",
        sortable: false,
      },
      {
        text: "Address",
        value: "user_type_name_temp",
        sortable: false,
      },
      {
        text: "VIP",
        value: "user_vip",
        sortable: false,
      },
      {
        text: "Actions",
        align: "center",
        value: "name",
        sortable: false,
      },
    ],
    editedIndex: null,
    alreadyCheckOTP: false,
    errSnackbar: false,
    snackBarMsg: null,
  }),
  components: {
    newUserDialog,
    addressList,
    editUserDialog,
  },
  computed: {
    ...mapState({
      indexEditLoading: (state) => state.fetchUserBack.indexEditLoading,
      userData: (state) => state.fetchUserBack.userData,
    }),
    ...mapGetters(["isEditStaff"]),
    pages() {
      this.pagination.totalItems = this.filterdUserData.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    filterdUserData() {
      return this.userData.filter((val) => {
        return val.user_role != 6;
      });
    },
  },
  methods: {
    ...mapActions({
      setUserToVIP: "fetchUserBack/setUserToVIP",
    }),
    cancelEdit() {
      this.selectedCustomer = null;
    },
    async editAddress(item) {
      this.selectedCustomer = item;
      this.fetching_address = item.user_id;
      this.selectedCustomer.user_address = await this.$store.dispatch(
        "fetchCustomerBack/getCustomerAddressDetail",
        item.user_id
      );
      console.log(this.selectedCustomer.user_address);
      this.fetching_address = null;
      this.addressListDialog = true;
      this.$store.dispatch("fetchCustomerBack/getProvinceAdd");
    },
    nameCheck(item) {
      item.user_full_name_temp =
        item.user_first_name + " " + item.user_last_name;
      return item.user_full_name_temp;
    },
    typeCheck(checkData) {
      if (checkData.user_type == "1") {
        checkData.user_type_name_temp = "Weserve";
      } else if (checkData.user_type == "2") {
        checkData.user_type_name_temp = "Facebook";
      }
      return checkData.user_type_name_temp;
    },
    roleCheck(checkData) {
      if (checkData.user_role == "1") {
        checkData.user_role_name_temp = "SuperAdmin";
      } else if (checkData.user_role == "2") {
        checkData.user_role_name_temp = "Admin";
      } else if (checkData.user_role == "3") {
        checkData.user_role_name_temp = "Viewer(Manager)";
      } else if (checkData.user_role == "4") {
        checkData.user_role_name_temp = "Callcenter";
      } else if (checkData.user_role == "6") {
        checkData.user_role_name_temp = "Customer";
      } else if (checkData.user_role == "7") {
        checkData.user_role_name_temp = "Store owner";
      } else if (checkData.user_role == "8") {
        checkData.user_role_name_temp = "RiderManager";
      } else if (checkData.user_role == "9") {
        checkData.user_role_name_temp = "Accounting";
      } else if (checkData.user_role == "10") {
        checkData.user_role_name_temp = "Marketing";
      } else if (checkData.user_role == "11") {
        checkData.user_role_name_temp = "AdminLaborStore";
      } else {
        checkData.user_role_name_temp = "Other";
      }
      return checkData.user_role_name_temp;
    },
    editItem(item) {
      this.editedIndex = this.userData.indexOf(item);
      this.selectedItem = item;
      this.originalUser = Object.assign({}, item);
      this.editDialog = true;
    },

    deleteItem(item) {
      const index = this.userData.indexOf(item);
      confirm(
        "Are you sure you want to delete this user ? \n* this user will change to customer."
      ) && this.$store.dispatch("fetchUserBack/deleteUser", item);
    },
    async getData() {
      this.loadingMessage = await this.$store.dispatch("fetchUserBack/getData");
    },
    async setVIP(value, item) {
      let result = await this.setUserToVIP({
        user_id: item.user_id,
        user_level_status: value.status,
        otp_pin: value.otp_pin,
        otp_ref: value.otp_ref,
        otp_tel: value.otp_tel,
      });
      if (result === false || result.msg == false) {
        item.user_vip = !item.user_vip;
        this.errSnackbar = true;
        this.snackBarMsg = result.data;
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>
